/* eslint-disable no-useless-escape */
import i18n from '@/i18n';
import { onHandleFakeId } from '@/utils/handlers';

const OPTION_IMPORT_SERIAL_CODE = [
    {
        id: 1,
        name: '上書き'
    },
    {
        id: 2,
        name: '追加'
    }
];

const STYLE_IMPORT = [
    {
        id: 1,
        name: '数字のみ'
    },
    {
        id: 2,
        name: '半角英数のみ'
    },
    {
        id: 3,
        name: '半角英数記号を含む（ 「_」「@」「#」「-」）'
    }
];

const CONFIG_TABLE_IMPORT = {
    isLoadingListSerial: false,
    headers: [
        {
            label: 'No.',
            width: 60
        },
        {
            label: 'シリアルコード',
            width: 300
        },
        {
            label: 'シリアルコード利用制限回数',
            width: 300
        },
        {
            label: '利用可能数',
            width: 180
        }
    ],
    configPage: {
        total: 0,
        limit: 50,
        page: 1,
        totalSerialCode: 0
    },
    configModalProgressSerialCode: {
        title: '',
        model: false,
        scrollable: true,
        hideFooter: true,
        centered: true,
        validate: true,
        size: 'md',
        hideCloseButton: false,
        title_excute: ''
    }
};

const LIST_NOTE_CHECK_USE_KEY = [
    {
        label: '0（ゼロ）／O（大文字オー）／o（小文字オー）'
    },
    {
        label: '1（イチ）／l（小文字エル）／I（大文字アイ）'
    },
    {
        label: '6（ロク）／b（小文字ビー）'
    },
    {
        label: '9（キュウ）／q（小文字キュー）'
    }
];

const SIMILAR_CHARACTER_GROUPS = ['0', 'O', 'o', '1', 'l', 'I', '6', 'b', '9', 'q'];

const initFormSerialCode = () => {
    return {
        serial_code: null,
        quantity_limit: 1,
        is_not_use_unique_key: false
    };
};

const configSerialCode = () => {
    return {
        serial_code: {
            errorField: i18n.t('managerForm.settingSerialCode.individualSerialCodeRegistration'),
            errorText: '',
            error: false,
            length: 15,
            errorCustomMess: '',
            typesValidate: ['required', 'maxCustom']
        },
        quantity_limit: {
            errorField: i18n.t('managerForm.settingSerialCode.limitNumberQuantity'),
            isNumber: true,
            error: false,
            maxlength: 5,
            typesValidate: ['required', 'max10']
        }
    };
};

const initAutoSerialCode = () => {
    return {
        number_serial: null,
        quantity_limit: 1,
        type_temp: STYLE_IMPORT[0].id,
        number_temp: null,
        is_not_use_unique_key: false
    };
};

const configAutoSerialCode = () => {
    return {
        number_serial: {
            errorField: i18n.t('managerForm.settingSerialCode.numberTitle'),
            isNumber: true,
            error: false,
            maxlength: 7,
            min: 1,
            max: 5000000,
            typesValidate: ['required', 'limit-input']
        },
        quantity_limit: {
            errorField: i18n.t('managerForm.settingSerialCode.limitNumberQuantity'),
            isNumber: true,
            error: false,
            maxlength: 5,
            typesValidate: ['required', 'max10']
        },
        number_temp: {
            errorField: i18n.t('managerForm.settingSerialCode.serialCodeOfDigits'),
            isNumber: true,
            error: false,
            min: 1,
            max: 16,
            typesValidate: ['required', 'limit-input']
        }
    };
};

const objectSerialCode = (data, listArr = []) => {
    return {
        make_id: onHandleFakeId(listArr),
        serial_code: data?.serial_code ?? null,
        quantity_limit: data?.quantity_limit ?? null
    };
};

const onHandleDuplicateSerialCode = (arrSerial, newSerial) => {
    let isDuplicate = false;
    if (arrSerial.length <= 0) return isDuplicate;
    arrSerial.forEach((item) => {
        if (item.serial_code.toString().trim() === newSerial.toString().trim()) {
            isDuplicate = true;
        }
    });
    return isDuplicate;
};

const onHandleExitSerial = (arrOrigin, newItem) => {
    const existSerial = arrOrigin.find((s) => s.serial_code === newItem.serial_code);
    if (!existSerial) {
        arrOrigin.push(objectSerialCode(newItem, arrOrigin));
        return;
    }
    existSerial.quantity_limit = newItem.quantity_limit;
};

const validateByCharSet = (trimmedInput) => {
    // Không chứa khoảng trắng
    if (/\s/.test(trimmedInput)) {
        return false;
    }

    // Chỉ cho phép chữ cái tiếng Anh, số, và 4 ký tự đặc biệt: -, _, @, #
    if (!/^[a-zA-Z0-9_\-@#]+$/.test(trimmedInput)) {
        return false;
    }

    const hasDigit = /[0-9]/.test(trimmedInput);
    const hasLetter = /[a-zA-Z]/.test(trimmedInput);
    const hasSpecial = /[_\-@#]/.test(trimmedInput);

    // Bắt buộc phải có số
    if (!hasDigit) {
        return false;
    }

    // Nếu có ký tự đặc biệt, bắt buộc phải có cả chữ (và số đã bắt buộc ở trên)
    // Trường hợp: Số và ký tự đặc biệt (ví dụ #11) -> return false
    if (hasSpecial && !hasLetter) {
        return false;
    }

    return true;
};

const validateNotSimilarCharacters = (inputValue) => {
    if (!inputValue) return true;
    return !SIMILAR_CHARACTER_GROUPS.some((character) => inputValue.includes(character));
};

export {
    OPTION_IMPORT_SERIAL_CODE,
    STYLE_IMPORT,
    CONFIG_TABLE_IMPORT,
    LIST_NOTE_CHECK_USE_KEY,
    initFormSerialCode,
    configSerialCode,
    objectSerialCode,
    initAutoSerialCode,
    configAutoSerialCode,
    onHandleDuplicateSerialCode,
    onHandleExitSerial,
    validateByCharSet,
    validateNotSimilarCharacters
};
